<p>installation-time works!</p>
